module.exports = __webpack_public_path__ + "static/media/feedback-stars.996e981d.png";